export default __webpack_public_path__ + "static/media/questions-md-2x.b37c5a40.png";